"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentAuditDateComparisonDtoVaccinationCodeEnum = void 0;
exports.instanceOfDocumentAuditDateComparisonDto = instanceOfDocumentAuditDateComparisonDto;
exports.DocumentAuditDateComparisonDtoFromJSON = DocumentAuditDateComparisonDtoFromJSON;
exports.DocumentAuditDateComparisonDtoFromJSONTyped = DocumentAuditDateComparisonDtoFromJSONTyped;
exports.DocumentAuditDateComparisonDtoToJSON = DocumentAuditDateComparisonDtoToJSON;
exports.DocumentAuditDateComparisonDtoToJSONTyped = DocumentAuditDateComparisonDtoToJSONTyped;
/**
 * @export
 */
exports.DocumentAuditDateComparisonDtoVaccinationCodeEnum = {
    Covid19: 'COVID_19',
    Hepatitis: 'HEPATITIS',
    Influenza: 'INFLUENZA',
    MeaslesMumpsRubella: 'MEASLES_MUMPS_RUBELLA',
    Tdap: 'TDAP',
    Varicella: 'VARICELLA'
};
/**
 * Check if a given object implements the DocumentAuditDateComparisonDto interface.
 */
function instanceOfDocumentAuditDateComparisonDto(value) {
    if (!('vaccinationCode' in value) || value['vaccinationCode'] === undefined)
        return false;
    if (!('claimedDate' in value) || value['claimedDate'] === undefined)
        return false;
    if (!('matched' in value) || value['matched'] === undefined)
        return false;
    return true;
}
function DocumentAuditDateComparisonDtoFromJSON(json) {
    return DocumentAuditDateComparisonDtoFromJSONTyped(json, false);
}
function DocumentAuditDateComparisonDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'vaccinationCode': json['vaccinationCode'],
        'claimedDate': json['claimedDate'],
        'matched': json['matched'],
    };
}
function DocumentAuditDateComparisonDtoToJSON(json) {
    return DocumentAuditDateComparisonDtoToJSONTyped(json, false);
}
function DocumentAuditDateComparisonDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'vaccinationCode': value['vaccinationCode'],
        'claimedDate': value['claimedDate'],
        'matched': value['matched'],
    };
}
//# sourceMappingURL=DocumentAuditDateComparisonDto.js.map